import { useCallback, useEffect, useMemo, useRef } from "react";
import NoSleep from "nosleep.js";

// Complete silent MP4 from NoSleep.js — proven to work on all iOS Safari versions.
// Contains proper H.264 video + AAC audio tracks (both silent) with moov/mdat boxes.
// iOS Safari requires a real playable video with audio track to prevent screen sleep.
const SILENT_MP4 =
  "data:video/mp4;base64,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";

const isIOSDevice = (): boolean => {
  return (
    /iPhone|iPad|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
};

export const useEnhancedWakeLock = () => {
  const wakeLockRef = useRef<WakeLockSentinel | null>(null);
  const noSleepRef = useRef<NoSleep | null>(null);
  const audioContextRef = useRef<AudioContext | null>(null);
  const audioSourceRef = useRef<OscillatorNode | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const domUpdateIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const healthCheckIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const shouldMaintainWakeLock = useRef(false);
  const activeStrategiesRef = useRef<Set<string>>(new Set());
  const visibilityDebounceRef = useRef<NodeJS.Timeout | null>(null);
  const hasUserInteraction = useRef(false);

  // Strategy 1: Native Wake Lock API (Safari 16.4+, Chrome, Edge)
  const requestNativeWakeLock = useCallback(async (): Promise<boolean> => {
    if (!("wakeLock" in navigator) || document.visibilityState !== "visible") {
      return false;
    }

    try {
      if (wakeLockRef.current && !wakeLockRef.current.released) {
        await wakeLockRef.current.release();
      }

      wakeLockRef.current = await (navigator as any).wakeLock.request("screen");

      wakeLockRef.current.addEventListener("release", () => {
        wakeLockRef.current = null;
        activeStrategiesRef.current.delete("native");
        // If we should still be maintaining, try to re-acquire
        if (shouldMaintainWakeLock.current && document.visibilityState === "visible") {
          setTimeout(() => {
            if (shouldMaintainWakeLock.current && !wakeLockRef.current) {
              requestNativeWakeLock();
            }
          }, 1000);
        }
      });

      activeStrategiesRef.current.add("native");
      return true;
    } catch (err) {
      console.log("[EnhancedWakeLock] Native wake lock failed:", (err as Error)?.message);
      return false;
    }
  }, []);

  // Strategy 2: NoSleep.js (plays hidden video on iOS Safari)
  const requestNoSleep = useCallback(async (): Promise<boolean> => {
    try {
      if (!noSleepRef.current) {
        noSleepRef.current = new NoSleep();
      }

      await noSleepRef.current.enable();
      activeStrategiesRef.current.add("nosleep");
      console.log("[EnhancedWakeLock] NoSleep.js enabled");
      return true;
    } catch (err) {
      console.log("[EnhancedWakeLock] NoSleep.js failed:", (err as Error)?.message);
      activeStrategiesRef.current.delete("nosleep");
      return false;
    }
  }, []);

  // Strategy 3: Silent Audio Loop
  // On iOS, uses a very low volume (not zero) to avoid being suspended
  const startSilentAudio = useCallback((): boolean => {
    try {
      if (!audioContextRef.current || audioContextRef.current.state === "closed") {
        audioContextRef.current = new (window.AudioContext || (window as any).webkitAudioContext)();
      }

      // Resume audio context if it was suspended (iOS does this aggressively)
      if (audioContextRef.current.state === "suspended") {
        audioContextRef.current.resume();
      }

      // Stop existing oscillator before creating new one
      if (audioSourceRef.current) {
        try {
          audioSourceRef.current.stop();
        } catch (_e) {
          /* ignore */
        }
        audioSourceRef.current = null;
      }

      const oscillator = audioContextRef.current.createOscillator();
      const gainNode = audioContextRef.current.createGain();

      // Use an extremely low but non-zero gain to prevent iOS from suspending
      // 0.001 is inaudible but iOS sees it as active audio
      gainNode.gain.value = isIOSDevice() ? 0.001 : 0;

      oscillator.frequency.value = 1; // Very low frequency
      oscillator.connect(gainNode);
      gainNode.connect(audioContextRef.current.destination);
      oscillator.start();
      audioSourceRef.current = oscillator;

      activeStrategiesRef.current.add("audio");
      console.log("[EnhancedWakeLock] Silent audio started");
      return true;
    } catch (err) {
      console.log("[EnhancedWakeLock] Silent audio failed:", (err as Error)?.message);
      return false;
    }
  }, []);

  // Strategy 4: Looping Video Element (iOS-specific, uses real MP4)
  const startVideoTrick = useCallback((): boolean => {
    try {
      // Clean up existing video
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.remove();
        videoRef.current = null;
      }

      const video = document.createElement("video");
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");
      video.muted = true;
      video.loop = true;
      video.style.position = "fixed";
      video.style.width = "1px";
      video.style.height = "1px";
      video.style.opacity = "0.01";
      video.style.left = "-10px";
      video.style.top = "-10px";
      video.style.pointerEvents = "none";
      video.style.zIndex = "-1000";

      // Use the exact same proven MP4 that NoSleep.js uses internally
      // This is a complete H.264 + AAC file that iOS Safari can play and loop
      video.src = SILENT_MP4;

      document.body.appendChild(video);
      videoRef.current = video;

      // Try to play - this needs user interaction on iOS
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            activeStrategiesRef.current.add("video");
            console.log("[EnhancedWakeLock] Video trick started");
          })
          .catch(() => {
            console.log("[EnhancedWakeLock] Video autoplay blocked - will retry on interaction");
            // Don't remove - we'll retry on next user interaction
          });
      }

      return true;
    } catch (err) {
      console.log("[EnhancedWakeLock] Video trick failed:", (err as Error)?.message);
      return false;
    }
  }, []);

  // Strategy 5: Periodic DOM + Touch Simulation (keeps JS engine active)
  const startDomUpdates = useCallback((): boolean => {
    try {
      if (domUpdateIntervalRef.current) {
        clearInterval(domUpdateIntervalRef.current);
      }

      let element = document.getElementById("wake-lock-heartbeat");
      if (!element) {
        element = document.createElement("div");
        element.style.position = "fixed";
        element.style.left = "-9999px";
        element.style.top = "-9999px";
        element.style.width = "1px";
        element.style.height = "1px";
        element.id = "wake-lock-heartbeat";
        document.body.appendChild(element);
      }

      // Update element more frequently on iOS (every 5 seconds vs 10)
      const interval = isIOSDevice() ? 5000 : 10000;
      domUpdateIntervalRef.current = setInterval(() => {
        element!.textContent = Date.now().toString();
        // Force a tiny style recalculation to keep the rendering engine awake
        element!.style.opacity = element!.style.opacity === "0.01" ? "0.02" : "0.01";
      }, interval);

      activeStrategiesRef.current.add("dom");
      return true;
    } catch (err) {
      return false;
    }
  }, []);

  // Health check: verify strategies are still working and restart dead ones
  const startHealthCheck = useCallback(() => {
    if (healthCheckIntervalRef.current) {
      clearInterval(healthCheckIntervalRef.current);
    }

    healthCheckIntervalRef.current = setInterval(
      () => {
        if (!shouldMaintainWakeLock.current || document.visibilityState !== "visible") {
          return;
        }

        console.log(
          "[EnhancedWakeLock] Health check - active strategies:",
          Array.from(activeStrategiesRef.current),
        );

        // Check native wake lock
        if ("wakeLock" in navigator && (!wakeLockRef.current || wakeLockRef.current.released)) {
          activeStrategiesRef.current.delete("native");
          requestNativeWakeLock();
        }

        // Check audio context - iOS suspends these aggressively
        if (audioContextRef.current) {
          if (audioContextRef.current.state === "suspended") {
            console.log("[EnhancedWakeLock] Audio context suspended, resuming...");
            audioContextRef.current.resume().catch(() => {
              // If resume fails, restart the whole audio strategy
              activeStrategiesRef.current.delete("audio");
              startSilentAudio();
            });
          } else if (audioContextRef.current.state === "closed") {
            activeStrategiesRef.current.delete("audio");
            audioContextRef.current = null;
            startSilentAudio();
          }
        }

        // Check video is still playing
        if (videoRef.current) {
          if (videoRef.current.paused || videoRef.current.ended) {
            console.log("[EnhancedWakeLock] Video stopped, restarting...");
            videoRef.current.play().catch(() => {
              activeStrategiesRef.current.delete("video");
            });
          }
        }

        // Re-enable NoSleep if it may have been disabled
        // NoSleep doesn't expose an "isEnabled" check, so we re-enable defensively on iOS
        if (isIOSDevice() && noSleepRef.current && hasUserInteraction.current) {
          noSleepRef.current.enable().catch(() => {
            activeStrategiesRef.current.delete("nosleep");
          });
        }
      },
      isIOSDevice() ? 15000 : 30000,
    ); // Check every 15s on iOS, 30s elsewhere
  }, [requestNativeWakeLock, startSilentAudio]);

  // Main request function - activates ALL strategies on iOS for maximum reliability
  const requestWakeLock = useCallback(async (): Promise<boolean> => {
    shouldMaintainWakeLock.current = true;
    hasUserInteraction.current = true;

    // IMPORTANT: On iOS, we don't short-circuit. We always re-enable everything
    // because iOS aggressively kills background processes and we can't trust
    // that any strategy is still actually working.
    console.log("[EnhancedWakeLock] Activating all wake lock strategies");

    const results: boolean[] = [];
    const isiOS = isIOSDevice();

    // Strategy 1: Native Wake Lock API (works on Safari 16.4+ and Chrome)
    results.push(await requestNativeWakeLock());

    // Strategy 2: NoSleep.js — always try on iOS, fallback elsewhere
    if (isiOS) {
      results.push(await requestNoSleep());
    }

    // Strategy 3: Silent audio — always run on iOS as backup
    if (isiOS) {
      results.push(startSilentAudio());
    }

    // Strategy 4: Video trick — always run on iOS
    if (isiOS) {
      results.push(startVideoTrick());
    }

    // If nothing worked so far on non-iOS, try remaining strategies
    if (!isiOS && !results.some((r) => r)) {
      results.push(await requestNoSleep());
      results.push(startSilentAudio());
    }

    // Strategy 5: DOM updates — only as fallback if no strategies succeeded
    if (!results.some((r) => r)) {
      startDomUpdates();
    }

    // Start health check to keep everything alive
    startHealthCheck();

    const success = results.some((r) => r) || activeStrategiesRef.current.size > 0;
    console.log("[EnhancedWakeLock] Active strategies:", Array.from(activeStrategiesRef.current));

    return success;
  }, [
    requestNativeWakeLock,
    requestNoSleep,
    startSilentAudio,
    startVideoTrick,
    startDomUpdates,
    startHealthCheck,
  ]);

  // Re-activate all strategies — called on user interaction (tap) while conversation is active
  const reactivateAll = useCallback(async () => {
    if (!shouldMaintainWakeLock.current) return;

    console.log("[EnhancedWakeLock] Reactivating all strategies on user interaction");
    hasUserInteraction.current = true;

    // Re-enable everything — user interaction gives us permission to play media
    await requestNativeWakeLock();

    if (isIOSDevice()) {
      await requestNoSleep();
      startSilentAudio();

      // Retry video play since we now have user interaction
      if (videoRef.current && videoRef.current.paused) {
        videoRef.current.play().catch(() => {});
      } else {
        startVideoTrick();
      }

      // Resume audio context if suspended
      if (audioContextRef.current?.state === "suspended") {
        audioContextRef.current.resume().catch(() => {});
      }
    }
  }, [requestNativeWakeLock, requestNoSleep, startSilentAudio, startVideoTrick]);

  // Release all active strategies
  const releaseWakeLock = useCallback(async () => {
    shouldMaintainWakeLock.current = false;

    // Stop health check
    if (healthCheckIntervalRef.current) {
      clearInterval(healthCheckIntervalRef.current);
      healthCheckIntervalRef.current = null;
    }

    // Release native wake lock
    if (wakeLockRef.current && !wakeLockRef.current.released) {
      try {
        await wakeLockRef.current.release();
      } catch (err) {
        console.error("[EnhancedWakeLock] Error releasing native wake lock:", err);
      } finally {
        wakeLockRef.current = null;
      }
    }

    // Disable NoSleep.js
    if (noSleepRef.current) {
      try {
        noSleepRef.current.disable();
      } catch (err) {
        console.error("[EnhancedWakeLock] Error disabling NoSleep:", err);
      }
    }

    // Stop audio
    if (audioSourceRef.current) {
      try {
        audioSourceRef.current.stop();
        audioSourceRef.current = null;
      } catch (err) {
        console.error("[EnhancedWakeLock] Error stopping audio:", err);
      }
    }

    if (audioContextRef.current) {
      try {
        await audioContextRef.current.close();
        audioContextRef.current = null;
      } catch (err) {
        console.error("[EnhancedWakeLock] Error closing audio context:", err);
      }
    }

    // Remove video element
    if (videoRef.current) {
      try {
        videoRef.current.pause();
        videoRef.current.removeAttribute("src");
        videoRef.current.load();
        videoRef.current.remove();
        videoRef.current = null;
      } catch (err) {
        console.error("[EnhancedWakeLock] Error removing video:", err);
      }
    }

    // Stop DOM updates
    if (domUpdateIntervalRef.current) {
      clearInterval(domUpdateIntervalRef.current);
      domUpdateIntervalRef.current = null;
      const element = document.getElementById("wake-lock-heartbeat");
      if (element) {
        element.remove();
      }
    }

    activeStrategiesRef.current.clear();
    // console.log("[EnhancedWakeLock] All strategies released");
  }, []);

  // Handle visibility changes — re-acquire ALL strategies when page becomes visible
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && shouldMaintainWakeLock.current) {
        // Clear any pending debounce
        if (visibilityDebounceRef.current) {
          clearTimeout(visibilityDebounceRef.current);
        }

        // Debounce slightly to avoid rapid re-acquisition
        visibilityDebounceRef.current = setTimeout(async () => {
          console.log("[EnhancedWakeLock] Page became visible, re-acquiring strategies");

          // Re-acquire native wake lock
          if (!wakeLockRef.current) {
            requestNativeWakeLock();
          }

          // Re-enable NoSleep on iOS
          if (isIOSDevice() && noSleepRef.current) {
            noSleepRef.current.enable().catch(() => {});
          }

          // Resume audio context
          if (audioContextRef.current?.state === "suspended") {
            audioContextRef.current.resume().catch(() => {});
          }

          // Restart video if stopped
          if (videoRef.current?.paused) {
            videoRef.current.play().catch(() => {});
          }
        }, 300);
      }
    };

    const handleBeforeUnload = () => {
      releaseWakeLock();
    };

    // On iOS, also listen for pageshow (back-forward cache)
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted && shouldMaintainWakeLock.current) {
        console.log("[EnhancedWakeLock] Page restored from bfcache, re-acquiring");
        handleVisibilityChange();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("pageshow", handlePageShow);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("pageshow", handlePageShow);
      if (visibilityDebounceRef.current) {
        clearTimeout(visibilityDebounceRef.current);
      }
      releaseWakeLock();
    };
  }, [requestNativeWakeLock, releaseWakeLock]);

  return useMemo(
    () => ({
      requestWakeLock,
      releaseWakeLock,
      reactivateAll,
      activeStrategies: activeStrategiesRef.current,
      isActive: () => activeStrategiesRef.current.size > 0,
    }),
    [requestWakeLock, releaseWakeLock, reactivateAll],
  );
};
